const videoblogSelectors = {
  placeholder: ".c-composition-videoblog--image",
  video: ".c-composition-videoblog--video",
};

window.addEventListener("DOMContentLoaded", function() {
  const placeholders = document.querySelectorAll(videoblogSelectors.placeholder);
  const videos = document.querySelectorAll(videoblogSelectors.video);
  if (placeholders.length && videos.length) {
    videoblogInit(placeholders, videos);
  }
});

function videoblogInit(placeholders, videos) {
  // video play video on image click
  for (let i = 0; i < placeholders.length; i++) {
    const img = placeholders[i].querySelector('img');
    img.src = img.dataset.src; // pre-load images for video blog to avoid potential issues with image lazyload
    placeholders[i].addEventListener('click', function(e) { // jshint ignore:line
      e.preventDefault();
      const video = this.parentNode.querySelector(videoblogSelectors.video);
      videoblogToggle(this, video);
    });
  }

  for (let i = 0; i < videos.length; i++) {
    videos[i].addEventListener('click', function(e) { // jshint ignore:line
      e.preventDefault();
      const video = this.parentNode.querySelector(videoblogSelectors.video);
      const placeholder = this.parentNode.querySelector(videoblogSelectors.placeholder);
      videoblogToggle(placeholder, video);
    });
  }
}

function videoblogToggle (placeholder, video) {
  const video_embed = video.querySelector('iframe');
  const video_height =  video.parentNode.scrollWidth / 16.0 * 9.0;

  if (video.classList.contains('play')) {
    video.classList.remove('play');
    placeholder.classList.remove('play');
    video_embed.src = '';
  } else {
    videoblogReset();
    videoblogSlideTo(video);
    video_embed.style.height = video_height + 'px';
    video_embed.src = videoblogFixURL(video_embed.dataset.src);
    video.classList.add('play');
    placeholder.classList.add('play');
  }
}

function videoblogFixURL(url) {
  return url.replace('://youtu.be/', '://www.youtube.com/embed/');
}

function videoblogReset() {
  const videos = document.querySelectorAll(videoblogSelectors.video);
  for (let i = 0; i < videos.length; i++) {
    videos[i].classList.remove('play');
    var video_embed = videos[i].querySelector('iframe');
    video_embed.src = '';
  }
  const placeholders = document.querySelectorAll(videoblogSelectors.placeholder);
  for (let i = 0; i < placeholders.length; i++) {
    placeholders[i].classList.remove('play');
  }
}

function videoblogSlideTo(video) {
  const slide = video.closest('.slick-slide').dataset.slickIndex;
  const slick = video.closest('.c-aggregator--slider');
  // console.log('slickGoTo(' + slide + ')');
  $(slick).slick('slickGoTo', slide);
}
